import { AccountManagementPageTestsSection } from './AccountManagementPageTestsSection';
import { AccountManagementPageStudiesSection } from './AccountManagementPageStudiesSection';
import { AccountManagementPageProfileSection } from './AccountManagementPageProfileSection';
import { AccountManagementPageSubscriptionSection } from './AccountManagementPageSubscriptionSection';
import { useState } from 'react';

export type AccountManagementPageProps = React.ComponentProps<'div'> & {};

export const AccountManagementPage = () => {
  // Hide the studies and VIE chat section as it not required for web
  const [hideStudiesSection] = useState(false);

  return (
    <section className="page-container flex flex-col gap-12">
      <AccountManagementPageProfileSection className="mb-5" />

      <AccountManagementPageSubscriptionSection />

      <AccountManagementPageTestsSection />

      {hideStudiesSection && (
        <AccountManagementPageStudiesSection />
      )}
    </section>
  );
};
